module.exports = __webpack_public_path__ + "img/chrome.22673265.svg";